<template>
    <div class="invoices">
        <div class="filters">
            <div class="client-filter">
                <div class="header">
                    <fa-icon :icon="['fas', 'user-circle']" />
                    <h5>Cliente</h5>
                </div>
                <div class="client-content">
                    <g-field
                        v-model="filters.client"
                        :app="app"
                        table="clients"
                        column-search="alias"
                        name="client"
                        placeholder="Cliente"
                        ret-label="alias"
                        :clean="true"
                        @input="changeClient"
                    />
                    <checkbox class="client-check" v-model="filters.allClients" size="md" label="Todos los clientes" />
                    <ul class="clients">
                        <li v-for="(item, index) in filters.clients" :key="index">
                            <tag :label="item.label" :color="item.color" @delete="handlerDeleteClient(item.key)" />
                        </li>
                    </ul>
                </div>
            </div>
            <div class="period-filter">
                <div class="header">
                    <fa-icon :icon="['fas', 'calendar-days']" />
                    <h5>Periodo</h5>
                </div>
                <div class="period-content">
                    <div class="start-date">
                        <h5>inicio</h5>
                        <g-field
                            v-model="filters.from"
                            :app="app"
                            name="date"
                            placeholder="Fecha Inicio"
                            :clean="true"
                        />
                    </div>
                    <div class="end-date">
                        <h5>fin</h5>
                        <g-field v-model="filters.to" :app="app" name="date" placeholder="Fecha Fin" :clean="true" />
                    </div>
                </div>
            </div>
            <div class="buttons-filter">
                <a-button type="primary" @click="handlerFilter">
                    <fa-icon :icon="['far', 'magnifying-glass-plus']" class="mr-2" /> Filtrar
                </a-button>
                <a-button @click="handlerFilter">
                    <fa-icon :icon="['fas', 'repeat']" />
                </a-button>
                <a-button @click="handlerCleanFilter">
                    <fa-icon :icon="['fas', 'broom-wide']" />
                </a-button>
            </div>
        </div>
        <div class="content">
            <g-table-sync
                ref="invoicesTable"
                :app="app"
                :view="view"
                :columns="columns"
                :default-limit="20"
                pagination="loadmore"
                hideClean
                hideSearch
                hideDelete
                hideRefresh
                hideStrict
                slotRButton
            >
                <template slot="head-right" slot-scope="data" v-if="isBoss">
                    <!-- Combinar albaranes en facturas unica -->
                    <div class="heading-rigth">
                        <a-tooltip v-if="data.select.length > 1" placement="top">
                            <template v-if="isEligibleForCombine(data.select).ok" slot="title">
                                {{ `Combinar ${data.select.length} albaranes a factura` }}
                            </template>

                            <template v-else slot="title">
                                {{ isEligibleForCombine(data.select).message }}
                            </template>

                            <a-button
                                :disabled="!isEligibleForCombine(data.select).ok"
                                :loading="converting"
                                @click="combineMultipleInvoicesToBills(data.select)"
                            >
                                <fa-icon v-show="!xport.loading" :icon="['fas', 'file-plus']" />
                            </a-button>
                        </a-tooltip>
                        <!-- Transformar a factura (multiple) -->
                        <a-tooltip placement="top">
                            <template slot="title">
                                {{
                                    data.select.length === 0
                                        ? 'No se han seleccionado albaranes'
                                        : `Transformar ${data.select.length} albaran/es a factura`
                                }}
                            </template>
                            <a-button
                                v-show="data.select.length"
                                :loading="converting"
                                @click="transformMultipleInvoicesToBills(data.select)"
                            >
                                <fa-icon v-show="!xport.loading" :icon="['fas', 'file-export']" />
                            </a-button>
                        </a-tooltip>
                    </div>
                </template>

                <!-- Empresa -->
                <template slot="client_name" slot-scope="{ item }">
                    <truncate tag="span" class="clickable" @click="$router.push(`/client/${item.client._EntityId}`)">
                        {{ item.client_name }}
                    </truncate>
                </template>

                <!-- Total -->
                <template slot="total" slot-scope="{ item }">
                    <span v-if="item.client.show_prices === 1 || isBoss"> {{ formatCurrency(item.total) }} </span>
                    <span v-else></span>
                </template>

                <!-- Transformar a factura (item) -->
                <template slot="actions" slot-scope="{ item }">
                    <g-item-actions app="invoices" :item="item" @edit="openForm" :delete="false">
                        <template slot="left">
                            <a-tooltip v-if="isBoss" placement="top">
                                <template slot="title"> Transformar a factura </template>
                                <a-button class="mr-2" :loading="converting" @click="transformInvoicesToBills([item])">
                                    <fa-icon :icon="['fas', 'file-export']" />
                                </a-button>
                            </a-tooltip>
                        </template>
                    </g-item-actions>
                </template>

                <template slot="_mobile" slot-scope="{ item, index, deleteItems }">
                    <ticket
                        :item="item"
                        :index="index"
                        :loading="printing === item._EntityId"
                        disabledDelete
                        @print-pdf="printInvoicePDFType"
                        @print-ticket="generateTicketAndPrint"
                        @open-invoice="openBill(item)"
                        @edit="openForm"
                    />
                </template>
            </g-table-sync>
        </div>
    </div>
</template>

<script>
import Pricing from '@/application/mixins/pricing.js'
import Transform from '../mixins/transform.js'
import Actions from './_actions'
import Variables from './_variables'
import Checkbox from '@/application/components/checkbox.vue'
import Tag from '@/application/components/tag.vue'

export default {
    mixins: [Actions, Pricing, Transform],
    components: { Checkbox, Tag },
    data() {
        return Variables()
    },
    computed: {
        columns() {
            const columns = []

            columns.push({
                title: 'Nº',
                index: 'serie',
                order: true,
                search: false,
            })

            columns.push({
                title: 'Empresa',
                index: 'client_name',
                order: true,
                search: false,
                slot: 'client_name',
            })

            columns.push({
                title: 'Fecha',
                index: 'date',
                order: true,
                slot: '_date',
                search: false,
            })

            columns.push({
                title: 'Total',
                index: 'total',
                order: true,
                search: false,
                slot: 'total',
            })

            columns.push({
                title: 'Acciones',
                slot: 'actions',
            })

            return columns
        },
        isBoss() {
            return this.$gestios.auth.check({ scopes: ['_BOSS'] })
        },
    },
    created() {
        this.$hub.$on('listInvoice', () => {
            this.$router.push({ name: 'invoices' })
        })
    },
    beforeDestroy() {
        this.$hub.$off('listInvoice')
    },
    mounted() {
        this.handlerFilter()
    },
}
</script>

<style lang="scss">
@import './styles.scss';
</style>
